import { UseTranslateProvider } from '@ur-solutions/react-hooks'
import messages from '@/locale/messages'
import { getPreferredLanguage, setPreferredLanguage } from '@/locale/util'
import React, { useMemo } from 'react'

interface IntlContextProviderProps {}

export const IntlContextProvider: React.JSX.CFC<IntlContextProviderProps> = ({
  children,
}) => {
  const initialLocale = getPreferredLanguage()

  const finalMessages = useMemo(() => {
    const finalMessages = {
      ...messages,
    }

    for (const lang of Object.keys(finalMessages)) {
      for (const [key, value] of Object.entries(
        finalMessages[lang as keyof typeof finalMessages]
      )) {
        if (value === 'NEEDS TRANSLATION') {
          const englishValue = (messages['en'] as any)[key]
          if (englishValue) {
            const l = lang as keyof typeof finalMessages
            const k = key as keyof (typeof finalMessages)[typeof l]
            finalMessages[l][k] = englishValue
          }
        }
      }
    }

    return finalMessages
  }, [])

  return (
    <UseTranslateProvider
      initialLocale={initialLocale}
      messages={finalMessages}
      onLocaleChange={locale => setPreferredLanguage(locale)}
    >
      {children}
    </UseTranslateProvider>
  )
}
